import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import moment from "moment";

import { findAllBySeller } from "src/api/quotationDraft";

import device from "src/styles/device";
import font from "src/styles/font";
import useDeviceSize from "src/hooks/useDeviceSize";

import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import SearchIcon from "@mui/icons-material/Search";
import IconButton from "@mui/material/IconButton";
import Stack from "@mui/material/Stack";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { DataGrid, GridActionsCellItem } from "@mui/x-data-grid";
import Button from "src/components/core/Button";

import AddIcon from "@mui/icons-material/Add";
import EditRoundedIcon from "@mui/icons-material/EditRounded";
import VisibilityIcon from "@mui/icons-material/Visibility";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import { useAuth } from "src/hooks/useAuth";

const DivMuiContainer = styled.div`
  width: 100%;
  height: auto;
  padding: 32px;
  border-radius: 32px;
  background-color: #ffffff;
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.1);
  // display: flex;
  justify-content: center;
  align-items: center;

  @media ${device.tabletL} {
    padding: 0;
    border-radius: 0;
    box-shadow: none;
  }
`;

const DivMuiInside = styled.div`
  width: 100%;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
`;

const WrapperSearch = styled.div`
  // margin-bottom: 32px;
  margin-right: 16px;
  width: 65%;
  position: relative;
  display: flex;
  justify-content: center;

  @media ${device.tabletL} {
    width: 75%;
    /* margin-right: 4px; */
  }
  @media ${device.mobileL} {
    width: 75%;
  }

  .TextField-without-border-radius fieldset {
    border-radius: 16px;
  }
  .MuiTextField-root {
    margin: 0;
  }
`;

const WrapperIcon = styled.div`
  /* display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center; */
  padding: 0px;
  width: max-content;
  max-width: 5%;
  margin: 0 auto;

  @media ${device.tabletL} {
    /* width: 5%; */
    max-width: 32px;
  }
`;

const WrapperButton = styled.div`
  /* display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center; */
  padding: 0px;
  width: 35%;
  max-width: 350px;
  margin-left: 16px;

  @media ${device.tabletL} {
    width: 20%;
    /* margin-left: 12px; */
  }
  @media ${device.mobileL} {
    width: max-content;
    max-width: 32px;
    margin-left: 14px;
  }

  .Button-Add {
    width: 100%;
    box-shadow:
      0px 3px 1px -2px rgba(0, 0, 0, 0.2),
      0px 2px 2px rgba(0, 0, 0, 0.14),
      0px 1px 5px rgba(0, 0, 0, 0.12);
    border-radius: 16px;
    height: 52px;
    padding: 12px 24px;
  }
  .Button-Add:focus {
    background-color: #e04132;
  }
  .Button-Add:hover {
    background-color: #e04132;
    opacity: 0.9;
  }
`;

const WrapperDataGrid = styled.div`
  height: 600px;
  width: 100%;
  background: var(--white-color);

  .MuiDataGrid-root {
    border: 1px solid #ffffff;
  }
  .MuiDataGrid-columnHeaders {
    background-color: #f5f5f5;
  }
  .MuiDataGrid-root .MuiDataGrid-columnSeparator--sideRight {
    color: #f5f5f5;
  }
  .MuiDataGrid-root .MuiDataGrid-columnHeader:focus-within {
    // outline: solid #f5f5f5 1px;
    outline: none;
  }
  .MuiDataGrid-root .MuiDataGrid-cell:focus {
    outline: none;
    border-bottom: solid #f5f5f5 1px 0 1px 0;
  }
  .MuiDataGrid-root .MuiDataGrid-row.Mui-selected {
    background-color: #ffffff;
  }

  @media ${device.tabletL} {
    height: 70dvh;
    border-radius: 24px;
    box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.1);

    .MuiDataGrid-root {
      border-radius: 24px;
    }
    .MuiDataGrid-columnHeaders {
      border-radius: 24px 24px 0 0;
    }
    .MuiDataGrid-columnHeader:first-child,
    .MuiDataGrid-cell:first-child {
      padding-left: 32px;
    }
    .MuiDataGrid-columnHeader:last-child,
    .MuiDataGrid-cell:last-child {
      padding-right: 32px;
    }
  }
  @media ${device.mobileL} {
    border-radius: 16px;

    .MuiDataGrid-root {
      border-radius: 16px;
    }
    .MuiDataGrid-columnHeaders {
      border-radius: 16px 16px 0 0;
    }
    .MuiDataGrid-columnHeader:first-child,
    .MuiDataGrid-cell:first-child {
      padding-left: 16px;
    }
    .MuiDataGrid-columnHeader:last-child,
    .MuiDataGrid-cell:last-child {
      padding-right: 16px;
    }
  }
`;

const ImageNoData = styled.image`
  width: 120px;
  height: 120px;
  background-image: url("https://xsurface-images.s3.ap-southeast-1.amazonaws.com/no+data.svg");
  background-repeat: no-repeat;
  background-size: 100%;
`;

const ImageNotFound = styled.image`
  width: 120px;
  height: 120px;
  background-image: url("https://xsurface-images.s3.ap-southeast-1.amazonaws.com/not+found.svg");
  background-repeat: no-repeat;
  background-size: 100%;
`;

const TextNoData = styled.pre`
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
`;

const QuoDraftListSeller = () => {
  const { user, checkAllowPermission } = useAuth();

  const navigate = useNavigate();
  const [quotationDraftList, setQuotationDraftList] = useState([]);

  const [dataSearch, setDataSearch] = useState({
    keyword: null,
    filter: "all",
    page: 0,
    page_size: 10,
  });
  const [rowCount, setRowCount] = useState(0);
  const [isLoading, setIsLoading] = useState(false);

  const [deviceWidth] = useDeviceSize();

  const [anchorEl, setAnchorEl] = useState(null);
  const openFilter = Boolean(anchorEl);
  const handleClickFilter = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleCloseFilter = () => {
    setAnchorEl(null);
  };

  const DesktopColumns = [
    {
      field: "project", // ?
      headerName: "Project",
      flex: 1.5,
      // width: 200,
      editable: false,
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => {
        return (
          <Box
            sx={{
              width: "100%",
              wordWrap: "break-word",
              py: 2,
              ...(params?.row?.status !== 0 && {
                color: "var(--darkgreen-color)",
              }),
            }}
          >
            {params?.row?.project} {/* // ! */}
          </Box>
        );
      },
    },
    {
      field: "name",
      headerName: "Name",
      flex: 1.5,
      // width: 200,
      editable: false,
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => {
        return (
          <Box
            sx={{
              width: "100%",
              wordWrap: "break-word",
              py: 2,
              ...(params?.row?.status !== 0 && {
                color: "var(--darkgreen-color)",
              }),
            }}
          >
            {params?.row?.contact?.full_name}
          </Box>
        );
      },
    },
    {
      field: "running_number",
      headerName: "Quotation No.",
      flex: 1.5,
      // width: 200,
      editable: false,
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => {
        return (
          <Box
            sx={{
              width: "100%",
              wordWrap: "break-word",
              py: 2,
              ...(params?.row?.status !== 0 && {
                color: "var(--darkgreen-color)",
              }),
            }}
          >
            {params?.row?.running_number}
          </Box>
        );
      },
    },
    {
      field: "createdAt",
      headerName: "Date Request",
      flex: 1,
      headerAlign: "center",
      align: "center",
      editable: false,
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => {
        return (
          <Box
            sx={{
              // width: "100%",
              wordWrap: "break-word",
              py: 2,
              ...(params?.row?.status !== 0 && {
                color: "var(--darkgreen-color)",
              }),
            }}
          >
            {params?.row?.createdAt
              ? moment(params?.row?.createdAt).format("DD-MM-YYYY")
              : "-"}
          </Box>
        );
      },
    },
    {
      field: "updatedAt",
      headerName: "Date Update",
      flex: 1,
      headerAlign: "center",
      align: "center",
      editable: false,
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => {
        return (
          <Box
            sx={{
              // width: "100%",
              wordWrap: "break-word",
              py: 2,
              ...(params?.row?.status !== 0 && {
                color: "var(--darkgreen-color)",
              }),
            }}
          >
            {params?.row?.updatedAt
              ? moment(params?.row?.updatedAt).format("DD-MM-YYYY")
              : "-"}
          </Box>
        );
      },
    },
    {
      field: "actions",
      type: "actions",
      headerName: "Action",
      flex: 0.5,
      sortable: false,
      disableColumnMenu: true,
      getActions: (params) => [
        <GridActionsCellItem
          icon={<EditRoundedIcon />}
          label="Edit"
          disabled={
            !checkAllowPermission("sale_features.can_create_saleQuotation") &&
            params.row.status !== 0
              ? true
              : false
          }
          // disabled={params.row.status === 2 ? true : false}
          onClick={() => navigate(`/sale-quotation/edit/${params.row._id}`)}
          showInMenu
        />,
        <GridActionsCellItem
          icon={<VisibilityIcon />}
          label="Detail"
          onClick={() => navigate(`/sale-quotation/detail/${params.row._id}`)}
          showInMenu
        />,
      ],
    },
  ];

  const MobileColumns = [
    {
      field: "project", // ?
      headerName: "Project",
      flex: 2,
      // width: 200,
      editable: false,
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => {
        return (
          <Box
            sx={{
              width: "100%",
              wordWrap: "break-word",
              py: 2,
              ...(params?.row?.status !== 0 && {
                color: "var(--darkgreen-color)",
              }),
            }}
          >
            {params?.row?.project} {/* // ! */}
          </Box>
        );
      },
    },
    {
      field: "running_number",
      headerName: "Quotation No.",
      flex: 2,
      // width: 200,
      editable: false,
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => {
        return (
          <Box
            sx={{
              width: "100%",
              wordWrap: "break-word",
              py: 2,
              ...(params?.row?.status !== 0 && {
                color: "var(--darkgreen-color)",
              }),
            }}
          >
            {params?.row?.running_number}
          </Box>
        );
      },
    },
    {
      field: "actions",
      type: "actions",
      headerName: "",
      flex: 0.5,
      sortable: false,
      disableColumnMenu: true,
      getActions: (params) => [
        <GridActionsCellItem
          icon={<EditRoundedIcon />}
          label="Edit"
          disabled={
            !checkAllowPermission("sale_features.can_create_saleQuotation") &&
            params.row.status !== 0
              ? true
              : false
          }
          // disabled={params.row.status === 2 ? true : false}
          onClick={() => navigate(`/sale-quotation/edit/${params.row._id}`)}
          showInMenu
        />,
        <GridActionsCellItem
          icon={<VisibilityIcon />}
          label="Detail"
          onClick={() => navigate(`/sale-quotation/detail/${params.row._id}`)}
          showInMenu
        />,
      ],
    },
  ];

  const NoRowsOverlay = () => {
    return (
      <Stack height="100%" alignItems="center" justifyContent="center">
        <ImageNoData></ImageNoData>
        <TextNoData>No Data</TextNoData>
      </Stack>
    );
  };

  const NoResultsOverlay = () => {
    return (
      <Stack height="100%" alignItems="center" justifyContent="center">
        <ImageNotFound></ImageNotFound>
        <TextNoData>Not Found</TextNoData>
      </Stack>
    );
  };

  const onSearchButton = (filter) => {
    setDataSearch({ ...dataSearch, filter: filter, page: 0 });
    setIsLoading(true);
    (async () => {
      if (user.role_id === 1) {
        // const { data } = await findAllQuotationList({ ...dataSearch, page: 0 });
        const { data } = await findAllBySeller({
          ...dataSearch,
          filter: filter,
          page: 0,
        });
        setQuotationDraftList(data.rows);
        setRowCount(data.count);
        setIsLoading(false);
      }
    })();
  };

  const handlePageChange = (newPage) => {
    // We have the cursor, we can allow the page transition.
    setDataSearch({ ...dataSearch, page: newPage });
  };

  useEffect(() => {
    setIsLoading(true);
    (async () => {
      if (user.role_id === 1) {
        // const { data } = await findAllQuotationList(dataSearch);
        const { data } = await findAllBySeller(dataSearch);
        setQuotationDraftList(data.rows);
        setRowCount(data.count);
        setIsLoading(false);
      }
    })();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataSearch.page]);

  return (
    <DivMuiContainer>
      <DivMuiInside>
        <WrapperSearch>
          <TextField
            id="search-input"
            placeholder="ค้นหาจากรหัสเท่านั้น"
            className="TextField-without-border-radius"
            sx={{
              m: 1,
              width: "100%",
              borderRadius: "16px",
            }}
            InputProps={{
              endAdornment: (
                <IconButton
                  id="button-search-quotation"
                  sx={{ padding: 0 }}
                  onClick={() => onSearchButton()}
                >
                  <SearchIcon sx={{ color: "#e04132", cursor: "pointer" }} />
                </IconButton>
              ),
            }}
            onChange={(e) => {
              setDataSearch({ ...dataSearch, keyword: e.target.value });
            }}
            onKeyUp={(e) => (e.code === "Enter" ? onSearchButton() : null)}
          />
        </WrapperSearch>

        <WrapperIcon>
          <IconButton
            id="filter-button"
            aria-label="filter"
            aria-controls={openFilter ? "basic-menu" : undefined}
            aria-haspopup="true"
            aria-expanded={openFilter ? "true" : undefined}
            sx={{
              width: "32px",
              height: "32px",
              backgroundColor: "var(--darkwhite-color)",
              color: "var(--secondary-color)",
            }}
            onClick={handleClickFilter}
          >
            <FilterAltIcon sx={{ fontSize: 16 }} />
          </IconButton>

          <Menu
            id="filter-menu"
            anchorEl={anchorEl}
            open={openFilter}
            onClose={handleCloseFilter}
            MenuListProps={{
              "aria-labelledby": "filter-button",
            }}
            sx={{
              mt: 2,
              ".MuiMenu-paper": {
                borderRadius: 6,
              },
              ".MuiMenu-list": {
                p: 0,
              },
              ".MuiMenuItem-root": {
                px: 3,
                py: 1,
                ":first-child": {
                  pt: 2,
                },
                ":last-child": {
                  pb: 2,
                },
              },
            }}
            transformOrigin={{ horizontal: "center", vertical: "top" }}
            anchorOrigin={{ horizontal: "center", vertical: "bottom" }}
          >
            <MenuItem
              onClick={() => {
                onSearchButton("draft");
              }}
            >
              Draft Quotation
            </MenuItem>
            <MenuItem
              onClick={() => {
                onSearchButton("complete");
              }}
            >
              Complete Quotation
            </MenuItem>
          </Menu>
        </WrapperIcon>

        <WrapperButton>
          {checkAllowPermission("sale_features.can_create_saleQuotation") ? (
            deviceWidth > 540 ? (
              <Button
                variant="contained"
                className="Button-Add"
                sx={{
                  width: "100%",
                  maxWidth: 350,
                  fontSize: font.size.sm,
                }}
                startIcon={<AddIcon />}
                onClick={() => navigate("/sale-quotation/new")}
              >
                {deviceWidth > 835 ? `สร้างใบเสนอราคาชั่วคราว` : `สร้าง`}
              </Button>
            ) : (
              <IconButton
                sx={{
                  width: "32px",
                  height: "32px",
                  backgroundColor: "var(--primary-color)",
                  color: "var(--white-color)",
                }}
                onClick={() => navigate("/sale-quotation/new")}
              >
                <AddIcon sx={{ fontSize: 16 }} />
              </IconButton>
            )
          ) : null}
        </WrapperButton>
      </DivMuiInside>

      <WrapperDataGrid>
        <DataGrid
          rows={quotationDraftList}
          getRowId={(row) => row._id}
          getRowHeight={() => "auto"}
          loading={isLoading}
          columns={deviceWidth > 835 ? DesktopColumns : MobileColumns}
          pageSize={10}
          rowCount={rowCount}
          paginationMode="server"
          page={dataSearch.page}
          onPageChange={(e) => handlePageChange(e)}
          rowsPerPageOptions={[10]}
          pagination
          disableSelectionOnClick
          components={{
            // Footer: CustomPagination,
            NoRowsOverlay,
            NoResultsOverlay,
          }}
          componentsProps={{
            basePopper: {},
          }}
          sx={{
            "& .MuiDataGrid-actionsCell": {
              transform: "rotate(90deg)",
            },
            ".MuiDataGrid-row": {
              minHeight: {
                xs: "60px !important",
                md: "80px !important",
              },
            },
          }}
        />
      </WrapperDataGrid>
    </DivMuiContainer>
  );
};

export default QuoDraftListSeller;
